import React, {Component} from "react";
import {connect} from "react-redux";
import {nest as d3Nest} from "d3-collection";
import Source from "./../../../items/Source";
import ClusterGroupTabs from "./../../../blocks/ClusterGroupTabs";
import {CLUSTERS_COLORS_MAP} from "./../../../../helpers/colors";

import "./ClustersProfile.css";
import MKLogo from "../../../svg/MKLogo";

class ClustersProfile extends Component {

  render() {
    const {clusters, baseUrl} = this.props;

    if (!clusters){
      return null;
    }

    return (
      <div id="fow-profile-clusters" className="fow-col fow-col-2-3 fow-md-col-1 fow-introduction-block-children">
        <ClusterGroupTabs>
          {clusters.map(group =>
            <div key={group.key} className="fow-row fow-lg-row-to-col-reverse fow-md-row-to-col-reverse">
              <div className="fow-col-1-2 fow-lg-col-1 fow-md-col-1">
                <img className="fow-img-responsive" alt="nuts3 map" src={`${baseUrl}home/map-clusters-${group.key}.svg`} />
              </div>
              <div className="fow-col-1-2 fow-lg-col-1 fow-md-col-1">
                {group.values.map(c =>
                  <div key={c.cluster_id}>
                    <div className="fow-font-text fow-font-size-lg">
                      <span className="fow-square-legend" style={{backgroundColor: CLUSTERS_COLORS_MAP[c.cluster_name]}}></span>{c.cluster_name}
                    </div>
                    <p className="fow-font-text fow-font-size-sm">{c.description_of_cluster}</p>
                  </div>
                )}
              </div>
            </div>
          )}
        </ClusterGroupTabs>
        <MKLogo/>
        <Source text="Source: McKinsey Global Institute analysis" />
      </div>
    );
  }
}

const mapStateToProps = state => {
  const clusters = state.db.data.dimensions.clusters ? state.db.data.dimensions.clusters.filter(c => c.description_of_cluster !== '') : [];
  return {
    baseUrl: state.settings.baseUrl,
    clusters: d3Nest().key(i => i.cluster_group_id).entries(clusters.filter(c => c.cluster_group_id>0)).sort((a,b)=>a.key>b.key?1:-1)
  };
};
const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ClustersProfile);
